module.exports = __webpack_public_path__ + "img/mubokuAScrn1.cd7a0acb.png";